import { render, staticRenderFns } from "./SignUpStepper.vue?vue&type=template&id=3c8bbdc2&"
import script from "./SignUpStepper.vue?vue&type=script&lang=js&"
export * from "./SignUpStepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c8bbdc2')) {
      api.createRecord('3c8bbdc2', component.options)
    } else {
      api.reload('3c8bbdc2', component.options)
    }
    module.hot.accept("./SignUpStepper.vue?vue&type=template&id=3c8bbdc2&", function () {
      api.rerender('3c8bbdc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Research/SignUpStepper.vue"
export default component.exports